import { render } from "./CustomYandexMap.vue?vue&type=template&id=6ab91e06&scoped=true&ts=true"
import script from "./CustomYandexMap.vue?vue&type=script&lang=ts"
export * from "./CustomYandexMap.vue?vue&type=script&lang=ts"

import "./CustomYandexMap.vue?vue&type=style&index=0&id=6ab91e06&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab91e06"]])

export default __exports__